var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1146",
    "data-name": "\\uADF8\\uB8F9 1146",
    transform: "translate(-1868 -807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1139",
    "data-name": "\\uADF8\\uB8F9 1139",
    transform: "translate(-4633 1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_129",
    "data-name": "\\uC0AC\\uAC01\\uD615 129",
    width: 24,
    height: 24,
    transform: "translate(6501 -234)",
    fill: "none",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "free-icon-font-minus-circle-10469730",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.333A8.333,8.333,0,1,1,18.333,10,8.343,8.343,0,0,1,10,18.333ZM14.167,10a.834.834,0,0,1-.833.833H6.667a.833.833,0,1,1,0-1.667h6.667A.834.834,0,0,1,14.167,10Z",
    transform: "translate(1870 809)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMinus);
export default __webpack_public_path__ + "static/media/ico_minus.935f4c35f51985a5c6696160ef42d55c.svg";
export { ForwardRef as ReactComponent };